import { useEffect, useState } from "react";
import { Box, Paper, Stack, Typography, Button } from "@mui/material";
import { alpha } from "@mui/material/styles";

export function CookiesPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      role="dialog"
      aria-labelledby="cookies-title"
      aria-describedby="cookies-desc"
      aria-live="polite"
      sx={(theme) => ({
        position: "fixed",
        right: 16,
        bottom: 16,
        width: "calc(100% - 32px)",
        maxWidth: 480,
        zIndex: theme.zIndex.snackbar + 1,
      })}
    >
      <Paper
        elevation={8}
        sx={(theme) => ({
          p: 2.5,
          borderRadius: 2,
          backdropFilter: "blur(6px)",
          backgroundColor: alpha(theme.palette.background.paper, 0.92),
          border: `1px solid ${alpha(theme.palette.primary.main, 0.24)}`,
        })}
      >
        <Stack spacing={1.25}>
          <Typography id="cookies-title" variant="subtitle1" fontWeight={700}>
            Cookies & Privacy
          </Typography>
          <Typography id="cookies-desc" variant="body2" color="text.secondary">
            We use cookies to improve the experience and provide personalized
            features. Manage your preferences or accept to continue.
          </Typography>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="flex-end"
            sx={{ mt: 1 }}
          >
            <Button onClick={declineCookies} variant="outlined" color="inherit">
              Decline
            </Button>
            <Button
              onClick={acceptCookies}
              variant="contained"
              sx={{
                backgroundColor: "#15803d",
              }}
            >
              Accept
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
